module.exports = __webpack_public_path__ + "static/media/icon_cancel_dark.5727f721.svg";